(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    class StickyHeader extends HTMLElement{connectedCallback(){this.header=document.querySelector('.section-header');this.currentScrollTop=0;this.onScrollHandler=this.onScroll.bind(this);window.addEventListener('scroll',this.onScrollHandler,false)}disconnectedCallback(){window.removeEventListener('scroll',this.onScrollHandler)}onScroll(){const s=window.pageYOffset||document.documentElement.scrollTop;if(s>this.currentScrollTop&&s>120){this.header.classList.add('shopify-section-header-hidden','shopify-section-header-sticky')}else if(s<this.currentScrollTop){this.header.classList.add('shopify-section-header-sticky','animate');this.header.classList.remove('shopify-section-header-hidden')}else if(s<=20){this.header.classList.remove('shopify-section-header-hidden','shopify-section-header-sticky','animate')}this.currentScrollTop=s}}customElements.define('sticky-header',StickyHeader);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["milkweed-shipping-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('milkweed-shipping-bar')) {
    customElements.define('milkweed-shipping-bar', class extends HTMLElement {
      connectedCallback() {
        const parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit'
        }).formatToParts(new Date());
        const part = type => parts.find(value => value.type === type).value;
        const today = part('year') + '-' + part('month') + '-' + part('day');
        const noon = new Date(today + 'T12:00:00Z');
        const sunday = new Date(noon);
        sunday.setUTCDate(noon.getUTCDate() + (7 - noon.getUTCDay()) % 7);
        const weekEnd = sunday.toISOString().slice(0, 10);
        const upcoming = this.dataset.dates.split(',').map(date => date.trim())
          .filter(date => /^\d{4}-\d{2}-\d{2}$/.test(date) && date >= today).sort();
        this.hidden = upcoming.length === 0;
        if (this.hidden) return;
        const thisWeek = upcoming.filter(date => date <= weekEnd);
        const shown = thisWeek.length ? thisWeek : upcoming.slice(0, 1);
        const formatter = new Intl.DateTimeFormat('en-US', {
          timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric'
        });
        const label = thisWeek.length ? this.dataset.weekLabel : this.dataset.nextLabel;
        this.querySelector('[data-shipping-message]').textContent = label + ' ' +
          shown.map(date => formatter.format(new Date(date + 'T12:00:00Z'))).join(' & ');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
